import styled from "@emotion/styled";

type DividerProps = {
  margin?: string;
  type?: "horizontal";
};

const Divider = styled.div<DividerProps>(({ theme, margin, type = "horizontal" }) => ({
  backgroundColor: theme.colors.sysBorderPrimary,
  ...(type === "horizontal" && {
    width: "100%",
    height: 1,
    margin: margin ?? "8px 0",
  }),
}));

export default Divider;
